'use strict';

var handleDeepProperty = require('./handleDeepProperty');

function deepGetProperty(obj, key, any) {
  return handleDeepProperty(obj, key, any, false);
}

module.exports = deepGetProperty;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/deepGetProperty.js
// module id = 65
// module chunks = 0